<template>
  <div>
    <template v-if="$route.name == 'score'">
      <ots-main-title :mainTopBtn="mainBtnArr" ref="mainTitle" :isShowSearchIcon="false"></ots-main-title>
      <ots-refer
        class="mb20"
        :selectList="teaSelectList"
        :request-form="requestForm"
        @search="getScoreList"
      />
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :batchOperBtn="batchOperBtn"
      ></ots-table-group-new>
      <ots-custom-dialog
        :dialog.sync="addDialog"
        :title="form.code ? '修改' : '添加课程'"
        width="40%"
      >
        <template v-slot:content>
          <div>
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item
                label="课程名称"
                class="childrenName"
                prop="courseName"
              >
                <el-input v-model="courseName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="启用状态">
                <el-radio-group>
                  <el-radio-button label="1">启用</el-radio-button>
                  <!-- <el-radio-button label=0>停用</el-radio-button> -->
                </el-radio-group>
              </el-form-item>
              <el-form-item label="通过分数设置 大于等于" prop="passScore">
                <el-input v-model="form.passScore"></el-input>分
              </el-form-item>
              <el-form-item label="优秀分数设置 大于等于" prop="excellentScore">
                <el-input v-model="form.excellentScore"></el-input>分
              </el-form-item>
              <el-form-item label="成绩显示方式">
                <el-radio-group v-model="form.scoreType">
                  <el-radio-button label="1">分数</el-radio-button>
                  <el-radio-button label="2">等级制</el-radio-button>
                  <el-radio-button label="3">合格/不合格</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="合格率百分比" class="rateStyle" v-if="form.scoreType == 3">
                            <el-input class="short" v-model="form.rate" placeholder="请输入"></el-input><em>%</em>
                        </el-form-item> -->

              <el-form-item
                label="等级设置"
                class="gradeStyle"
                v-if="form.scoreType == 2"
              >
                <div
                  v-for="(item, index) in form.form_gradeList"
                  :key="index"
                  class="mb10"
                >
                  <el-input
                    class="input-w160"
                    placeholder="请输入等级名称"
                    v-model="item.name"
                  ></el-input>
                  <span class="span-w">分数≥</span>
                  <el-input
                    class="short"
                    placeholder="录入等级分数"
                    v-model="item.score"
                  ></el-input>
                  <i
                    v-if="index > 0"
                    class="ml42 iconfont icon-shanchu"
                    @click="deleteGrade(index)"
                  ></i>
                </div>
                <p class="col_blue mt10 cp" @click="addGrade">
                  <i class="el-icon-plus mr5"></i><span>增加等级</span>
                </p>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="cancelDialog">取消</el-button>
          <el-button round type="primary" @click="addCourse">确定</el-button>
        </template>
      </ots-custom-dialog>
    </template>

    <template v-else>
      <router-view />
    </template>
    <ots-custom-dialog :dialog.sync="importDialog" title="导入成绩" width="40%">
      <template v-slot:content>
        <div class="exportDialog">
          <el-form ref="exportForm" :model="importForm">
            <el-form-item label="1.模板下载">
              <span
                style="color: #006aff"
                @click="$getStaticFile('成绩导入.xlsx')"
                class="cp"
              >
                <i class="el-icon-download"></i>
                下载成绩导入数据模板
              </span>
            </el-form-item>
            <el-form-item label="2.选择文件" v-model="importForm.file">
              <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
            </el-form-item>
          </el-form>
          <div class="impExplain">
            <span class="tipTitle"><i></i>提示：</span>
            <div>
              <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
              <div>
                2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="importDialog = false">取消</el-button>
        <el-button round type="primary" @click="scoreImport">确定</el-button>
      </template>
    </ots-custom-dialog>
    <ots-custom-dialog :dialog.sync="importDialogmsg" title="导入成绩" width="40%">
          <template v-slot:content>
            <div class="exportDialog">
              <el-form ref="exportForm" :model="importForm">
                <el-form-item label="1.模板下载">
                  <span style="color:#006AFF;" @click="getStaticFile" class="cp">
                      <i class="el-icon-download"></i>
                      下载考试异常状态导入数据模板
                  </span>
                </el-form-item>
                <el-form-item label="2.选择文件" v-model="importForm.file">
                  <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
                </el-form-item>
              </el-form>
              <div class="impExplain">
                <span class="tipTitle"><i></i>提示：</span>
                <div>
                  <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                  <div>2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；</div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="importDialogmsg=false">取消</el-button>
            <el-button round type="primary" @click="scoreImportmsg" >确定</el-button>
          </template>
    </ots-custom-dialog>


    <ots-custom-dialog :dialog.sync="publishScoreDialog" title="提示" width="40%">
      <template v-slot:content>
        <div class="exportDialog">
          <p>批次下存在未处理完成的 <span style="color: #FE5958; font-weight: 700;"> {{ exemptNum }}名 </span>免考学生，确定要成绩发布么？</p>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="publishScoreDialog = false">取消</el-button>
        <el-button round type="primary" @click="publishScoreFn" >确定</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>
<script>
import { mapMutations } from "vuex";


import {
  changeCourseScoreSets,
  getPlanCoursePublishFn,
  publishStudentScoreFn,
  getCourseScore,
  scoreImportecxel,
  getEnableScoreImportpland,
  importCheckStateFileexcel,
  getCheckStateTemplateexcel,
  exportSubCourseScoreAPI,
  publishPreJudgeExemptAPI,
  getPlanPartInfoAPI
} from "@/http/modules/examSet/score";
import {
  getEnableSyncExamStateInfo,
  syncCheckStateSet,
  getEnableSyncCheckStateInfo,
} from "@/http/modules/examSet/journal";
import {
  getCurrentPlanFn,
  getSinglePlan,
  getSelectPlanFn,
  getPagePlan,
} from "@/http/modules/examSet/examBatch";
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
const scoreType = {
  1: "分数",
  2: "等级制",
  3: "合格/不合格",
};

export default {
  name: "score",
  data() {
    return {
      batchOperBtn: [
        {
          title: "成绩导出",
          icon: "iconfont icon-daochu",
          click: this.export,
        },
      ],

      mainBtnData: "",
      importForm: {
        file: "",
      },
      importDialogmsg: false,
      importDialog: false,
      getEnableScoreData: "",
      pLanCourseId: "",
      courseName: "",
      addDialog: false,
      form: {
        courseName: "",
        scoreType: 1,
        rate: 60,
        passScore: "",
        excellentScore: "",
        form_gradeList: [{ score: "", name: "" }],
      },
      rules: {
        passScore: [
          { required: true, message: "请输入通过分数", trigger: "blur" },
          //{ type: "number", message: "通过分数只能为数字", trigger: "blur" },
        ],
        excellentScore: [
          { required: true, message: "请输入优秀分数", trigger: "blur" },
          // { type: "number", message: "优秀分数只能为数字", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入课程名称", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "输入范围在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        rate: [
          // { required: true, message: '课程合格率必填', trigger: 'blur'},
          {
            type: "number",
            message: "课程合格率必须为数字值",
            trigger: "blur",
          },
        ],
      },
      currentPlanName: "",
      tableHeader: [
        {
          title: "考试课程",
          prop: "courseName",
        },
        {
          title: "成绩显示方式",
          prop: "scoreType",
          formatter: (val) => scoreType[val.row.scoreTypeId],
        },
        {
          title: "平均分",
          prop: "avgScore"
        },
        // {
        //   title: "是否为综合课",
        //   prop: "courseFlag",
        //   formatter: (val) => (val.row.courseFlag == 1 ? "是" : "否"),
        // },
        {
          title: "试算结果",
          prop: "scoreTotalTest",
        },
        {
          title: "显示设置",
          type: "button",
          formatter: (val) =>
            val.row.scoreTotalTest ? "修改设置" : "修改设置",
          disableFn: (val) => (val.row.scoreTotalTest ? true : false),
          click: this.changeSet,
        },
        {
          title: "成绩发布状态",
          prop: "placeNames",
          formatter: (val) => (val.row.scorePublish == 1 ? "已发布" : "未发布"),
        },
        {
          title: "操作",
          type: "buttons",
          width: "240",
          fixed: "right",
          btnList: [
            {
              title: (scope) => (scope.row.scorePublish == 1 ? "" : "试算"),
              disableFn: (scope) => scope.row.scorePublish == 1 ? true : false,
              click: this.checkSingleData,
            },
            {
              title: "查看详情",
              click: this.currentScore,
            },
            {
              title: (scope) => {return scope.row.courseFlag != 1 ? "": "查看单科详情"},
              formatter: (scope) => {return scope.row.courseFlag != 1 ? true: false},
              click: this.singleDetail,
            }
          ],
        },
      ],
      tableData: [],
      scoreListForm: {
        type: 0, // 0数据请求1试算数据请求
      },
      mainBtnArr: [
        {
          title: "成绩试算",
          fn: this.checkScore,
          plain: true,
        },
        {
          title: "一键发布",
          fn: this.publishScore,
        },
      ],
      teaSelectList: [
        {
          title: "考试批次",
          type: "select",
          isSearch: true,
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "课程",
          type: "select",
          multiple: true,
          requestKey: "courseIds",
          label: "courseName",
          value: "courseId",
          data: [],
        },
        {
          title: "成绩显示方式",
          type: "select",
          multiple: true,
          requestKey: "courseTypes",
          label: "name",
          value: "id",
          data: [
            {
              name: "分数",
              id: 1,
            },
            {
              name: "等级制",
              id: 2,
            },
            {
              name: "合格/不合格",
              id: 3,
            },
          ],
        },
      ],
      requestForm: {
        planId: null,
        courseIds: [],
        courseTypes: [],
        type: 0,
      },
      publishScoreDialog: false,
      exemptNum: 0,
    };
  },
  computed: {
    mainTopBtnList() {
      let btnArr;
      if (this.currentPlanFromStore.scorePublish == 1) {
        btnArr = [];
      } else {
        btnArr = this.mainBtnArr;
      }
      return btnArr;
    },
  },
  watch: {
    /******************************
     * @this 批次切换更新数据
     *****************************/
    "requestForm.planId"(val) {
      this.getCurrentInfo();
      this.initCourseList(val);
      this.getScoreList();
      this.isShowSyncBtn(val);
    },
    // "$route"(){
    //   this.$nextTick(() => {
    //     this.$refs["mainTitle"] && this.$refs["mainTitle"].hideSearchIcon();
    //   })
    // }
  },
  created() {
    this.planId = this.$route.query.id;
    this.initData();
    // this.isShowSyncBtn();
  },
  mounted() {
    // this.$refs["mainTitle"] && this.$refs["mainTitle"].hideSearchIcon();
    // this.SAVE_PAGE_THIS(this)
  },

  methods: {

    async export() {
      const { data, code } = await exportSubCourseScoreAPI({planId: this.requestForm.planId});
      if (code) {
        window.open(data);
      }
    },

    // 页面跳转 => 查看单科详情
    singleDetail(row) {
        this.$router.push({
          name: "singleGrades",
          query: {
            planCode: this.currentPlan.code,
            planName: this.currentPlan.name,
            planId: this.currentPlan.id,
            courseId: row.courseId,
            courseName: row.courseName,
            scorePublish: row.scorePublish,
          },
        });


      /* 
        this.$router.push({
          name: "currentScore",
          query: {
            planCode: this.currentPlan.code,
            planName: this.currentPlan.name,
            planId: this.currentPlan.id,
            courseId: row.courseId,
            courseName: row.courseName,
            scorePublish: row.scorePublish,
          },
        });
      */
    },

    getStaticFile(){
      getCheckStateTemplateexcel().then((res)=>{
      window.location.href = res.data
      })
    },
    deleteGrade(index) {
      this.form.form_gradeList.splice(index, 1);
    },
    importStationDialog() {
      this.importDialog = true;
    },
    importStationDialogmsg() {
      this.importDialogmsg = true;
    },
    handleFormData(val) {
      this.importForm.file = val.file;
    },
    async scoreImport() {
      // (1) 文件选择判断
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importForm.file);
      formData.append("planId", this.requestForm.planId);
      const { code, data } = await scoreImportecxel(formData);
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const totalNum = parseInt(data.allCount);
        const successNum = totalNum - failNum;
        let message = `导入完成，成功导入${successNum}，失败数${failNum}`;
        this.importDialog = false;
        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address;
          }
        });
        this.importDialog = false;
      } else {
        this.importDialog = false;
      }
    },
    async scoreImportmsg() {
      // (1) 文件选择判断
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importForm.file);
      formData.append("planId",this.requestForm.planId);
      const { code, data } = await importCheckStateFileexcel(formData);
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const successCount = data.successCount;
        let message = `导入完成，成功导入${successCount}，失败数${failNum}`;
        this.importDialog = false;
        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address;
          }
        });
        this.importDialogmsg = false;
      } else {
        this.importDialogmsg = false;
      }
    },
    addCourse() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let params = {
            name: this.form.name,
            scoreType: this.form.scoreType,
            planCourseId: this.form.planCourseId,
            passScore: this.form.passScore,
            excellentScore: this.form.excellentScore,
          };
          if (this.form.scoreType == 2) {
            // 等级制
            let gradeSet = this.form.form_gradeList.filter((item) => item.name);
            if (!gradeSet.length) {
              this.$message.error("请设置有效的等级制");
              return false;
            }
            params.gradeSet = JSON.stringify(gradeSet);
          }
          if (this.form.scoreType == 3) {
            // 合格率
            let rate = parseFloat(this.form.rate);
            if (isNaN(rate) || rate < 0) {
              this.$message.error("请设置有效的合格率");
              return false;
            }
            params.rate = parseInt(this.form.rate);
          }
          const { code } = await changeCourseScoreSets(params);
          if (code == 1) {
            this.$message.success("操作成功");
            this.getScoreList();
            this.cancelDialog();
          }
        } else {
          return false;
        }
      });
    },
    cancelDialog() {
      this.resetForm();
      this.addDialog = false;
    },
    addGrade() {
      let obj = {
        score: "",
        name: "",
      };
      this.form.form_gradeList.push(obj);
    },
    ...mapMutations(["SAVE_PAGE_THIS"]),
    goHistory() {
      this.$router.push({
        name: "historyScore",
      });
    },

    /********************************
     * @isShowSyncBtn 是否展示异常同步按钮
     ********************************/
    isShowSyncBtn(val) {
      // 1. 是否展示按钮
      getEnableSyncCheckStateInfo({
        planId: this.requestForm.planId,
      }).then(({ data }) => {
        this.mainBtnData = data;
        getEnableScoreImportpland({ planId: val }).then((res) => {
          this.getEnableScoreData = res.data;
          if (this.mainBtnData == 1) {
            if (this.getEnableScoreData == 1) {
              this.mainBtnArr = [
                {
                  title: "同步考试异常状态",
                  fn: this.examErrSync,
                  plain: true,
                },
                {
                  title: "成绩导入",
                  fn: this.importStationDialog,
                  plain: true,
                },
                {
                  title: "考试异常状态导入",
                  fn: this.importStationDialogmsg,
                  plain: true,
                },
                {
                  title: "成绩试算",
                  fn: this.checkScore,
                  plain: true,
                },
                {
                  title: "一键发布",
                  fn: this.publishScore,
                },
              ];
            } else {
              this.mainBtnArr = [
                {
                  title: "同步考试异常状态",
                  fn: this.examErrSync,
                  plain: true,
                },
                {
                  title: "考试异常状态导入",
                  fn: this.importStationDialogmsg,
                  plain: true,
                },
                {
                  title: "成绩试算",
                  fn: this.checkScore,
                  plain: true,
                },
                {
                  title: "一键发布",
                  fn: this.publishScore,
                },
                
              ];
            }
          } else {
            if (this.getEnableScoreData == 1) {
              this.mainBtnArr = [
                {
                  title: "成绩导入",
                  fn: this.importStationDialog,
                  plain: true,
                },
                {
                  title: "考试异常状态导入",
                  fn: this.importStationDialogmsg,
                  plain: true,
                },
                {
                  title: "成绩试算",
                  fn: this.checkScore,
                  plain: true,
                },
                {
                  title: "一键发布",
                  fn: this.publishScore,
        
                },
              ];
            } else {
              this.mainBtnArr = [
              {
                  title: "考试异常状态导入",
                  fn: this.importStationDialogmsg,
                  plain: true,
                },
                {
                  title: "成绩试算",
                  fn: this.checkScore,
                  plain: true,
                },
                {
                  title: "一键发布",
                  fn: this.publishScore,
                 
                },
              ];
            }
          }


          



        });
      });
    },
    /*********************************
     * @initCourseList 课程随着批次变化
     ********************************/
    async initCourseList(val) {
      /* *** 根据批次获取课程 *** */
      this.requestForm.courseIds = [];
      const { data: courseData } = await getPlanCourseFn({ planId: val });
      this.teaSelectList[1].data = courseData;
    },

    /********************************
     * @examErrSync 同步考试违纪状态
     ********************************/
    examErrSync() {
      this.$confirm("确认同步当前考试异常状态？", "提示", {
        type: "warning",
      })
        .then(() => {
          syncCheckStateSet({
            planId: this.requestForm.planId,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success("同步成功！");
            }
          });
        })
        .catch(() => {});
    },
    resetForm() {
      this.form = {
        courseName: "",
        scoreType: 1,
        rate: 60,
        passScore: "",
        excellentScore: "",
        form_gradeList: [{ score: "", name: "" }],
      };
    },
    async initData() {
      let { data } = await getSelectPlanFn({ needAudit: 6 });
      this.$set(this.teaSelectList[0], "data", data);
      if (data.length) {
        this.requestForm.planId = data[0].id;
        this.getCurrentInfo();
      }
      this.getScoreList();
    },
    // async initData() {
    //   let { data } = await getSelectPlanFn({ needAudit: 6 });
    //   this.$set(this.teaSelectList[0], "data", data);
    //   if (data.length) {
    //     this.requestForm.planId = data[0].id;
    //     this.getCurrentInfo();
    //   }
    //   this.getScoreList();
    // },
    // 当前考试批次
    async getCurrentInfo() {
      let res = await getCurrentPlanFn({
        planId: this.requestForm.planId,
      });
      this.currentPlan = res.data;
    },
    async getScoreList() {
      this.requestForm.type = 0;
      let params = Object.assign({}, this.requestForm, {
        courseIds: this.requestForm.courseIds.toString(),
        courseTypes: this.requestForm.courseTypes.toString(),
      });
      const { data } = await getPlanCoursePublishFn(params);
      this.tableData = data;
    },
    async checkScore() {
      this.requestForm.type = 1;
      let params = Object.assign({}, this.requestForm, {
        courseIds: this.requestForm.courseIds.toString(),
        courseTypes: this.requestForm.courseTypes.toString(),
      });
      const { data } = await getPlanCoursePublishFn(params);
      if (data) {
        this.tableData = data;
      }
    },
    checkSingleData(val) {
      const { courseId, scoreTypeId } = val;
      getPlanCoursePublishFn({
        type: 1,
        courseIds: courseId,
        courseTypes: scoreTypeId,
        planId: this.requestForm.planId,
      }).then(({ data }) => {
        const singleData = data.length && data[0];
        if (singleData) {
          this.tableData.forEach((item) => {
            if (item.courseId == singleData.courseId) {
              item.scoreTotalTest = singleData.scoreTotalTest;
            }
          });
        }
      });
    },
    async publishScore() {
      this.$confirm("成绩发布后将无法撤销和修改，是否确定发布?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const { data } = await getPlanPartInfoAPI({planId: this.requestForm.planId});
        if (data.allowViewExamScoreFlag === 1) {
          this.publishScoreNext();
          return;
        }
        let { data: exemptNum } = await publishPreJudgeExemptAPI({ planId: this.requestForm.planId });
        if (exemptNum > 0) {
          this.exemptNum = exemptNum;
          this.publishScoreDialog = true;
        } else {
          this.publishScoreFn();
        }
      }).catch(() => {});
    },

    publishScoreNext() {
      this.$confirm("考试批次下设置了不允许学生查看成绩，发布后学生端无法查看，是否确定发布？", "提示", {
        confirmButtonText: "确定发布",
        cancelButtonText: "去设置",
        type: "warning",
      }).then(async () => {
        let { data: exemptNum } = await publishPreJudgeExemptAPI({ planId: this.requestForm.planId });
        if (exemptNum > 0) {
          this.exemptNum = exemptNum;
          this.publishScoreDialog = true;
        } else {
          this.publishScoreFn();
        }
      }).catch(() => {
        let planId = this.requestForm.planId;
        this.$router.push({name: "editBatch", query: {"id": planId}})
      });
    },


    async publishScoreFn() {
      const { code } = await publishStudentScoreFn({ planId: this.requestForm.planId, judgeExempt: 0, judgeThirdScore: 1 });
      if (code == 1) {
        this.$message.success("成绩发布成功，可到成绩查询功能查询");
        this.getScoreList();
        this.mixin_updateCurrentPlanInfo();
      }
      this.publishScoreDialog = false;
    },

    currentScore(row) {
      this.$router.push({
        name: "currentScore",
        query: {
          planCode: this.currentPlan.code,
          planName: this.currentPlan.name,
          planId: this.currentPlan.id,
          courseId: row.courseId,
          courseName: row.courseName,
          scorePublish: row.scorePublish,
        },
      });
    },
    changeSet(val) {
      this.courseName = val.courseName;
      this.form.planCourseId = val.planCourseId;
      this.form.scoreType = val.scoreType;
      this.addDialog = true;
      this.CourseScore();
    },
    async CourseScore() {
      let { data } = await getCourseScore({
        planCourseId: this.form.planCourseId,
      });
      this.form.passScore = data.passScore;
      this.form.excellentScore = data.excellentScore;
      this.form.scoreType = data.scoreType;
      let gradeSet = JSON.parse(data.gradeSet);
      if (gradeSet) {
        this.form.form_gradeList = gradeSet;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  flex: 1;
}
</style>
